import {InputSpinner} from "bootstrap-input-spinner/src/InputSpinner.js"

/*
 * Input spinner
 */
export function initInputSpinner(elem = document) {
    let inputSpinnerTriggerList = [].slice.call(elem.querySelectorAll("[data-provider='input-spinner']"));
    inputSpinnerTriggerList.map(function (spinnerTriggerEl) {
        return new InputSpinner(spinnerTriggerEl, {
                buttonsClass: "btn-soft-primary",
                min: 0
            });
        });
}
